// extracted by mini-css-extract-plugin
export default {"root":"AddHTab_root__sT5Sq","add-icon":"AddHTab_add-icon__q8ts6","text":"AddHTab_text__eH+aQ"};